import { useId, type ReactNode } from 'react'
import { Button } from './Button'
import { Dialog, DialogActions, DialogBody } from './Dialog'

export type ConfirmDialogProps = {
  open: boolean
  title: string
  description?: ReactNode
  confirmText?: string
  cancelText?: string
  danger?: boolean
  loading?: boolean
  onConfirm: () => void
  onClose: () => void
}

export function ConfirmDialog({ open, title, description, confirmText = '确认', cancelText = '取消', danger = false, loading = false, onConfirm, onClose }: ConfirmDialogProps) {
  const descriptionId = useId()
  return (
    // 描述是 ReactNode，落地带 id 的节点并把 id 传给 Dialog，让读屏能关联到描述内容
    <Dialog open={open} title={title} onClose={onClose} pending={loading} closePolicy="not-while-pending" ariaDescribedBy={description ? descriptionId : undefined}>
      <DialogBody>
        {description ? <div id={descriptionId} className="text-sm leading-6 text-[var(--color-muted)]">{description}</div> : null}
        <DialogActions>
          <Button variant="secondary" onClick={onClose} disabled={loading}>{cancelText}</Button>
          <Button variant={danger ? 'danger' : 'primary'} loading={loading} loadingMode="spinner" onClick={onConfirm} data-dialog-initial-focus>{confirmText}</Button>
        </DialogActions>
      </DialogBody>
    </Dialog>
  )
}
